module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/31bc4953d6286b30920ef5a53878e875.jpg";